import { createService } from 'common-package/src/services';

import { GateWayInstance, RbacGateWayInstance, LoginGateWayInstance } from './axiosInstances';

const service = createService({
  GateWayInstance,
  RbacGateWayInstance,
  LoginGateWayInstance,
});

export default service;
